<style>
    .swiper-nav-wrapper-prev {
        background: none !important;
        left: -16px;
        font-size: 16px;
    }
    .swiper-nav-wrapper-next {
        background: none !important;
        right: -16px;
        font-size: 16px;
    }
    .swiper-button-prev:after,
    .swiper-button-next:after {
        content: '' !important;
    }
    .swiper-container {
        width: 100%;
        height: 100%;
        position: relative;
        overflow: hidden;
    }
    .swiper-wrapper.auto .swiper-slide {
        width: auto !important;
        height: auto !important;
    }
    .swiper-button-disabled{
        opacity: 0.5;
    }
</style>
<script>
    import {Swiper, Navigation} from "swiper";
    Swiper.use([Navigation]);
    import 'swiper/swiper.min.css'
    import 'swiper/modules/navigation/navigation.min.css'

    export default {
        props: ['id', 'options', 'prev', 'next'],
        data: function () {
            return {
                swiper: null
            };
        },
        created: function () {

        },
        mounted: function () {
            var self = this;
            this.initIntersection(document.getElementById(this._id), this.initCarousel);
        },
        computed: {
            _id: function () {
                return this.id || 'carousel-' + parseInt(Math.random() * 100000);
            },
            carousel_options: function(){
                var id = '#' + this._id;
                var options = this.options || {
                    direction: 'horizontal',
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                    loop: false,
                    freeMode: false,
                    navigation: {}
                };
                
                if(this.prev){
                    options.navigation = options.navigation || {};
                    options.navigation.prevEl =`${id}-prev`;
                }
                if(this.next){
                    options.navigation = options.navigation || {};
                    options.navigation.nextEl = `${id}-next`;
                }
                return options;
            },
            wrapper_classes: function(){
                var classes = [];
                if(this.carousel_options.slidesPerView === 'auto'){
                    classes.push('auto');
                }
                return classes;
            }
        },
        watch: {

        },
        methods: {
            initIntersection: function(el, cb){
                if(!el){
                    return;
                }
                var self = this;
                if(!this.io){
                    this.io = new IntersectionObserver(entries => {
                        entries.forEach(function(entry) {
                            if(entry.isIntersecting){
                                let target = entry.target;
                                if(!target.__loaded && target.__cb){
                                    target.__cb();
                                    target.__loaded = true;
                                    self.io.unobserve(target);
                                }
                            }
                        });
                    }, {});
                }

                el.__loaded = false;
                el.__cb = cb;
                this.io.observe(el);
            },
            initCarousel: function () {
                var id = '#' + this._id;
                this.swiper = new Swiper(id, this.carousel_options);
            },
            nextSlide: function(){
                this.swiper.slideNext();
            }
        },
        filters: {

        }
    };
</script>

<template>
    <div class="position-relative">
        <div class="swiper-container">
            <div :id="_id">
                <div class="swiper-wrapper" :class="wrapper_classes">
                    <slot></slot>
                </div>
            </div>
        </div>
        <template v-if="prev">
            <div :id="_id + '-prev'" class="swiper-nav-wrapper swiper-nav-wrapper-prev">
                <button class="btn btn-default swiper-button-prev btn-icon rounded-circle" aria-label="Show previous slide">
                    <i class="fas fa-chevron-left fa-fw icon-color"></i>
                </button>
            </div>
        </template>
        <template v-if="next">
            <div :id="_id + '-next'" class="swiper-nav-wrapper swiper-nav-wrapper-next">
                <button class="btn btn-default swiper-button-next btn-icon rounded-circle" aria-label="Show next slide">
                    <i class="fas fa-chevron-right fa-fw icon-color"></i>
                </button>
            </div>
        </template>
    </div>
</template>



// WEBPACK FOOTER //
// resources/views/rd/assets/js/v2/components/misc/carousel.vue